import _ from 'lodash';

const initialState = {
  newNotification: false,
  selectedItem: null,
  view: false,
  id: null,
};

const Model = {
  namespace: 'actionNotification',

  state: initialState,

  effects: {
    *addNewNotification({ payload }, { put }) {
      yield put({
        type: 'addNotification',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewNotification',
          payload,
        });
      }
    },
  },

  reducers: {
    addNotification(state, { payload }) {
      return {
        ...state,
        newNotification: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewNotification(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    clearState() {
      return initialState;
    },
  },
};

export default Model;
